export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY';
export const SET_CURRENT_SUBCATEGORY = 'SET_CURRENT_SUBCATEGORY';
export const SET_IS_CATEGORY_TAB_VISIBLE = 'SET_IS_CATEGORY_TAB_VISIBLE';
